import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import memoize from 'memoize-one';

import Avatar from '@material-ui/core/Avatar';

const SVGsLocation = '/mapbox/sprites/svgs';

const size = 10; // Should be passed through as a prop and into the styles and svg

class KeySwatch extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        className: PropTypes.string,
        styling: PropTypes.object
    };

    constructor (props) {
        super(props);

        this.state = {
        };
    }

    createBox = (key, styles, sprite=null) => {
        const classes = this.props.classes;
        return (
            <div className={classNames(classes.swatch, classes.box)}
                key={key}
                style={styles}>
                {sprite && <img src={`${SVGsLocation}/${sprite}.svg`} width={size} height={size} />}
            </div>
        );
    };

    getSwatches = (styling) => {
        const { classes } = this.props;
        const swatches = [];

        if (styling) {
            styling.layers.forEach((layerStyle, key) => {
                switch (layerStyle.type) {
                    case 'circle':
                        let radius = layerStyle.paint['circle-radius'];
                        if (typeof(radius) !== 'number') radius = size * 0.5;
                        radius = Math.max(Math.min(size * 0.5, radius), 2);
                        swatches.push(
                            <div className={classNames(classes.swatch, classes.circle)} key={key}>
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                    width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${size} ${size}`}>
                                    <circle cx={`${size * 0.5}px`} cy={`${size * 0.5}px`} r={radius} fill={layerStyle.paint['circle-color']} />
                                </svg>
                            </div>
                        );
                        break;
                    case 'line':
                        let lp = layerStyle.paint['line-pattern'];
                        let lo = layerStyle.paint['line-opacity'];
                        if (lp) {
                            let styles = {};
                            if (lo) styles.opacity = lo;
                            swatches.push(this.createBox(key, styles, lp));
                        } else {
                            swatches.push(
                                <div className={classNames(classes.swatch, classes.line)}
                                    key={key}
                                    style={{ backgroundColor: layerStyle.paint['line-color'] }}
                                />
                            );
                        }
                        break;
                    case 'fill':
                        let foc = layerStyle.paint['fill-outline-color'];
                        let fc = layerStyle.paint['fill-color'];
                        let fo = layerStyle.paint['fill-opacity'];
                        let styles = {};
                        if (fc) {
                            if (fc.constructor.name === 'Array') {
                                // TODO: style mapbox "interpolate", etc.
                                break;
                            }
                            styles.backgroundColor = fc;
                        }
                        if (foc) {
                            styles.border = '1.5px solid ' + foc;
                            styles.boxSizing = 'border-box';
                        }
                        if (fo) styles.opacity = fo;

                        swatches.push(this.createBox(key, styles, layerStyle.paint['fill-pattern']));
                        break;
                    case 'fill-extrusion':
                        swatches.push(this.createBox(key, { backgroundColor: layerStyle.paint['fill-extrusion-color'] }));
                        break;
                    case 'symbol':
                        const sprite = layerStyle.layout['icon-image'];
                        if (typeof(sprite) === 'string') { swatches.push(this.createBox(key, null, sprite)); }
                        break;
                    case 'raster':
                        swatches.push(
                            <div className={classNames(classes.swatch, classes.box)}
                                key={key}
                                style={{ backgroundColor: '#aaa' }}
                            >
                                R
                            </div>
                        );
                        break;
                }

            });
        }

        if (swatches.length === 0) {
            // console.log("Layer: ", layer);
            swatches.push (
                <Avatar style={{ backgroundColor: '#aaa' }}
                    key={0}
                    className={classNames(classes.swatch, classes.box)}>
                    ?
                </Avatar>
            );
        }

        return swatches;
    };

    getMemoizedSwatches = memoize(
        (styling) => this.getSwatches(styling)
    );

    render () {
        const { classes, className, styling } = this.props;
        const swatches = this.getMemoizedSwatches(styling);

        return (
            <div className={classNames(classes.wrapper, className)}>
                {swatches}
            </div>
        );
    }
}

const style = theme => ({
    wrapper: {
        position: 'relative',
        width: size,
        height: size
    },
    swatch: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        '&> *': {
            position: 'absolute'
        }
    },
    box: {
        width: size,
        height: size
    },
    line: {
        width: size,
        height: size * 0.2,
        marginTop: size * 0.4,
        marginBottom: size * 0.4
    },
    circle: {
    }
});

export default withStyles(style)(KeySwatch);